export default "__VITE_ASSET__09fbb63a__"